import { resolve } from 'url';
import { Box, Grid, Typography } from '@mui/material';
import { useRouter } from 'next/router';
import { FC } from 'react';
import YearCard from '@components/Sitemap/Decision/YearCard';
import { DecisionsPageProps } from '@screens/Sitemap/Decisions';

interface SitemapContentProps extends DecisionsPageProps {
    title: string;
}
const NO_YEAR = 'NoYear';

const SitemapContent: FC<SitemapContentProps> = ({ title, years }) => {
    const { asPath } = useRouter();
    // Add trailing slash at end of asPath
    // Ex: /sitemap/decisions -> /sitemap/decisions/
    const asPathWithTrailingSlash = asPath.endsWith('/') ? asPath : `${asPath}/`;
    const hasNoYear = years.includes(NO_YEAR);

    return (
        <Box key={title} component="section">
            {title && (
                <Typography mt={6} variant="h2">
                    {title}
                </Typography>
            )}

            <Grid spacing={1.5} sx={{ mt: 3 }} container>
                {years.map((year: string) => (
                    <Grid key={year} item>
                        <YearCard
                            key={year}
                            href={resolve(asPathWithTrailingSlash, year)}
                            variant="filled"
                            year={year}
                        />
                    </Grid>
                ))}
            </Grid>
            {hasNoYear && (
                <Grid sx={{ mt: 1.5 }} container>
                    <Grid item>
                        <YearCard
                            href={resolve(asPathWithTrailingSlash, NO_YEAR)}
                            variant="filled"
                        />
                    </Grid>
                </Grid>
            )}
        </Box>
    );
};

export default SitemapContent;
